(() => {
  const initCarousel = (root = document) => {
    root.querySelectorAll('[data-related-carousel-root]').forEach((carouselRoot) => {
      if (carouselRoot.dataset.relatedInit === '1') return;
      carouselRoot.dataset.relatedInit = '1';

      const track = carouselRoot.querySelector('[data-related-track]');
      const prev = carouselRoot.querySelector('[data-related-prev]');
      const next = carouselRoot.querySelector('[data-related-next]');
      if (!track || !prev || !next) return;

      const step = () => Math.max(track.clientWidth * 0.86, 220);

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCarousel(document));
  } else {
    initCarousel(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCarousel(event.target);
  });
})();
